import * as types from "../actions/ActionTypes";

const initialState = {
  loading: false,
  invoiceConfigurationsList: [],
  invoiceConfigurationsMeta: null,
  invoiceConfigurationRecord: null,
  validation_error: {},
  redirectToList: false,
  showUpdateForm: false,
  showViewPage: false,
};

const InvoiceConfigurationReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.INVOICE_CONFIG_REQUEST:
      return {
        ...state,
        loading: true,
        redirectToList: false,
      };

    case types.INVOICE_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        invoiceConfigurationsList: action.invoiceConfigurationsList || [],
        invoiceConfigurationsMeta: action.meta || null,
      };

    case types.INVOICE_CONFIG_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        invoiceConfigurationRecord: action.record,
        showUpdateForm: action.actionType === "update",
        showViewPage: action.actionType === "view",
      };

    case types.INVOICE_CONFIG_VALIDATION_ERROR:
      return {
        ...state,
        loading: false,
        validation_error: action.validation_error || {},
      };

    case types.HIDE_INVOICE_CONFIG_FIELD_VALIDATION_ERROR: {
      const errors = { ...(state.validation_error || {}) };
      if (action.field_key) {
        delete errors[action.field_key];
      }
      return {
        ...state,
        validation_error: errors,
      };
    }

    case types.INVOICE_CONFIG_REDIRECT_TO_LIST:
      return {
        ...state,
        loading: false,
        redirectToList: true,
        showUpdateForm: false,
        showViewPage: false,
      };

    default:
      return state;
  }
};

export default InvoiceConfigurationReducer;
